var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-3" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Доставка с хладагентом")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.cool,
              expression: "drug.cool",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r1", value: "1" },
          domProps: { checked: _vm._q(_vm.drug.cool, "1") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "cool", "1")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r1" } }, [
          _vm._v("Да"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.cool,
              expression: "drug.cool",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r2", value: "0" },
          domProps: { checked: _vm._q(_vm.drug.cool, "0") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "cool", "0")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r2" } }, [
          _vm._v("Нет"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Аэрозоль под давлением")]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.is_press_can,
              expression: "drug.is_press_can",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r_press_can", value: "1" },
          domProps: { checked: _vm._q(_vm.drug.is_press_can, "1") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "is_press_can", "1")
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "r_press_can" } },
          [_vm._v("Да")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.is_press_can,
              expression: "drug.is_press_can",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r_press_can", value: "0" },
          domProps: { checked: _vm._q(_vm.drug.is_press_can, "0") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "is_press_can", "0")
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: "r_press_can" } },
          [_vm._v("Нет")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3" }, [
      _c("label", { attrs: { for: "" } }, [
        _vm._v("Льготная стоимость доставки"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.lgot_price,
              expression: "drug.lgot_price",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r3", value: "1" },
          domProps: { checked: _vm._q(_vm.drug.lgot_price, "1") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "lgot_price", "1")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r3" } }, [
          _vm._v("Да"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.drug.lgot_price,
              expression: "drug.lgot_price",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r4", value: "0" },
          domProps: { checked: _vm._q(_vm.drug.lgot_price, "0") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.drug, "lgot_price", "0")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r4" } }, [
          _vm._v("Нет"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3" }, [
      _c("label", { attrs: { for: "" } }, [
        _vm._v("Государственная регистрация"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.detail.use.value,
              expression: "detail.use.value",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r5", value: "1" },
          domProps: { checked: _vm._q(_vm.detail.use.value, "1") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.detail.use, "value", "1")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r5" } }, [
          _vm._v("Да"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.detail.use.value,
              expression: "detail.use.value",
            },
          ],
          staticClass: "form-check-input",
          attrs: { type: "radio", id: "r6", value: "0" },
          domProps: { checked: _vm._q(_vm.detail.use.value, "0") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.detail.use, "value", "0")
            },
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form-check-label", attrs: { for: "r6" } }, [
          _vm._v("Нет"),
        ]),
      ]),
      _vm._v(" "),
      +_vm.detail.use.value
        ? _c("div", { staticClass: "flex" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.detail.type.value,
                    expression: "detail.type.value",
                  },
                ],
                staticClass: "form-control registration_type_select",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.detail.type,
                      "value",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "0" } }, [_vm._v("Бессрочно")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v("Дата окончания"),
                ]),
              ]
            ),
            _vm._v(" "),
            +_vm.detail.type.value === 1
              ? _c(
                  "div",
                  { staticClass: "ml-2" },
                  [
                    _c("DateSelectProps", {
                      ref: "selectedDate",
                      attrs: {
                        disabled: false,
                        useDisabledDates: false,
                        selectedDate: _vm.detail.date.value,
                        onSelect: (date) => (this.detail.date.value = date),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }